import api from '~/api'

const state = {
  apiKey: {},
  permissions: [],
}

const getters = {}

const mutations = {
  SET_API_KEY(state, apiKey) {
    state.apiKey = apiKey
  },
  SET_SCOPES(state, permissions) {
    state.permissions = permissions
  },
}

const actions = {
  async createApiKey({ commit }, form) {
    const [error, success] = await api.post('/api-keys', form)
    if (!error) {
      commit('SET_API_KEY', success)
    }
    return [error, success]
  },
  async updateApiKey({ commit }, { id, form }) {
    const [error, success] = await api.patch(`/api-keys/${id}`, form)
    if (!error) {
      commit('SET_API_KEY', success)
    }
    return [error, success]
  },
  async deleteApiKey({ commit }, id) {
    const [error, success] = await api.delete(`/api-keys/${id}`)
    if (!error) {
      commit('SET_API_KEY', {})
    }
    return [error, success]
  },
  async showApiKey({ commit }, id) {
    const [error, success] = await api.get(`/api-keys/${id}`)
    if (!error) {
      commit('SET_API_KEY', success)
    }
    return [error, success]
  },
  async getScopes({ commit }) {
    const [error, data] = await api.get('/permissions')

    if (!error) {
      const { permissions } = data

      const groups = {}

      for (const scope of permissions) {
        const [group, name] = scope.split(':')

        if (!groups[group]) {
          groups[group] = [name]
        } else {
          groups[group].push(name)
        }
      }

      const groupedScopes = []
      const keys = Object.keys(groups)
      for (const key of keys) {
        groupedScopes.push({
          group: key,
          permissions: groups[key],
        })
      }

      commit('SET_SCOPES', groupedScopes)
    }
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
}
